import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Question = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 9a1 1 0 0 0-.879.522 1 1 0 1 1-1.754-.96A3 3 0 0 1 12 7c1.515 0 2.567 1.006 2.866 2.189.302 1.189-.156 2.574-1.524 3.258A.62.62 0 0 0 13 13a1 1 0 0 1-2 0c0-.992.56-1.898 1.447-2.342.455-.227.572-.618.48-.978C12.836 9.314 12.529 9 12 9'
          fill='currentColor'
        />
        <path d='M13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0' fill='currentColor' />
        <circle cx='12' cy='12' r='9' stroke='currentColor' strokeWidth='1.5' />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m-.879 7.272A1 1 0 0 1 12 9c.528 0 .835.314.928.68.09.36-.026.751-.48.978A2.62 2.62 0 0 0 11 13a1 1 0 1 0 2 0c0-.234.132-.448.342-.553 1.368-.684 1.826-2.07 1.524-3.258C14.566 8.006 13.515 7 12 7a3 3 0 0 0-2.633 1.562 1 1 0 0 0 1.754.96M12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2'
        fill='currentColor'
      />
    )}
  </IconBase>
);
